
import './skills.css'
import {data} from './skillsData'
import SkillsCard from './SkillsCard'
import { motion } from 'framer-motion';
import { useMemo } from 'react';
function Skills() {
  const MemoizedData = useMemo(() => data, []);
  return (
    <section id='skills'>
      <motion.h5 whileInView={{ opacity: 1, y: 0 }}
      initial={{ opacity: 0, y: -50 }}
      transition={{
        duration:1.25,type: "spring",
      }}>Tech Stacks</motion.h5>
      <motion.h2 whileInView={{ opacity: 1, y: 0 }}
      initial={{ opacity: 0, y: -50 }}
      transition={{
        duration:1.25,type: "spring",delay:0.3
      }}>Tech stacks & Tools</motion.h2>
      <div className="container SkillContainer">
          {
            MemoizedData.map((item)=>(
              <>
              <SkillsCard key={item.id} image={item.image} title={item.title} url={item.url} />
              </>
            ))
          }
      </div>
    </section>
  )
}

export default Skills